import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "react-query";
import { AppProvider } from "./contexts";
import { queryClient } from "./services/queryClient";
import App from "./App";
import "./index.css";
import "swiper/css";
import "./lib/posthog"

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.Fragment>
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <App />
      </AppProvider>
    </QueryClientProvider>
  </React.Fragment>
);
